import { services } from "@/core";
import HyperlinkDropDown from "../../components/HyperlinkDropDown.vue";
import ListControllerMixin from "../../utils/ListControllerMixin";

export default {
  mixins: [ListControllerMixin],
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  data() {
    return {
      copied: false,
      columns: [
        {
          name: "Substância",
          sortName: null,
          order: null,
        },
        {
          name: "Classe terapêutica",
          sortName: null,
          order: null,
        },
        {
          name: "Nome comercial",
          sortName: null,
          order: null,
        },
        {
          name: "",
          sortName: null,
          order: null,
        },
      ],
    };
  },
  components: {
    HyperlinkDropDown,
  },
  methods: {
    fetchPromise() {
      return services.medicinesService.list({
        ...this.filters,
        orderBy: this.columns.filter(
          (r) => r.order != null && r.sortName != null,
        ),
      });
    },
    prepareResponse(data) {
      // return data;
      return data.map((elem) => ({
        ...elem,
        names: elem.names.length
          ? elem.names
              .map((n) => n.name)
              .join(", ")
              .limitString(20)
          : "",
        compound: elem.compound ? elem.compound.limitString(60) : "",
        detail_url_copied: false,
        // treatment_methods: elem.treatment_methods.limitString(60),
      }));
    },
    copyURL(item, index, hyperlink) {
      this.$set(this.items[index], "detail_url_copied", true);
      setTimeout(() => {
        this.$set(this.items[index], "detail_url_copied", false);
      }, 3000);
      this.$helper.copyUrlWithHyperlinkTag(
        `${this.$paths.medicines.detail}/${item.id}`,
        hyperlink,
      );
    },
  },
};
